import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c987dc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-slot-by-day-resources" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-3c987dc3><g clip-path=\"url(#clip0_3503_3169)\" data-v-3c987dc3><path d=\"M10 2.88375V2.87975L12.994 4.22075L16 3.09375L8 0.09375L0 3.09375L8 6.09375L10.994 4.97075L8 3.73675V3.73375L10 2.88375Z\" fill=\"#0F172A\" data-v-3c987dc3></path><path d=\"M0 4.09375V13.0938L7.5 15.9067V6.90675L0 4.09375ZM4 13.1267L2 12.3767V11.3097L4 12.0597V13.1267Z\" fill=\"#0F172A\" data-v-3c987dc3></path><path d=\"M13 5.21875V7.72375L11 8.47375V5.96875L8.5 6.90675V15.9067L16 13.0938V4.09375L13 5.21875Z\" fill=\"#0F172A\" data-v-3c987dc3></path></g><defs data-v-3c987dc3><clipPath id=\"clip0_3503_3169\" data-v-3c987dc3><rect width=\"16\" height=\"16\" fill=\"white\" data-v-3c987dc3></rect></clipPath></defs></svg>", 1)
const _hoisted_3 = {
  class: "time-slot-by-day-resources__badge",
  style: {"padding":"6px 8px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-left":"14px"} }, "Заполнено", -1))
const _hoisted_5 = { class: "badge__number number--green" }
const _hoisted_6 = {
  class: "time-slot-by-day-resources__badge",
  style: {"padding":"6px 8px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-left":"14px"} }, "Ресурс", -1))
const _hoisted_8 = { class: "badge__number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.usage || '0'), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.limit), 1)
    ])
  ]))
}